// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });


    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

    window.addEventListener('resize', function(event){
      setTimeout(function(){
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

      },100);
    });



    $('.about-team-tabs').each(function(index, el) {
      let t = $(el);
      let t_l = t.find('.about-team-tab');

      if(t_l.length > 0){
        t_l.removeClass('-active');
        $(t_l[0]).addClass('-active');
        if($(t_l[0]).attr('id')){
          t.find('.dots-tabs .dot-tabs').removeClass('-active');
          t.find('.dots-tabs .dot-tabs[data-tab="'+$(t_l[0]).attr('id')+'"]').addClass('-active');
        }
      }

      t.find('.dots-tabs .dot-tabs').click(function(event) {
        t_l.removeClass('-active');
        t.find('#'+$(this).data('tab')).addClass('-active');
        t.find('.dots-tabs .dot-tabs').removeClass('-active');
        if($(this).data('tab')){
          t.find('.dots-tabs .dot-tabs[data-tab="'+$(this).data('tab')+'"]').addClass('-active');
        }
      });
    });



    const scrollers = document.querySelectorAll(".scroller");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", true);

        const scrollerInner = scroller.querySelector(".scroller__inner");
        const scrollerContent = Array.from(scrollerInner.children);

        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    }    

    $('.hover-trg').on('mouseover', function (e) {
      e.preventDefault();
      if ($(window).width() > 769) {
        //$('body').toggleClass("active-form-contact");
        $(this).closest('.hover-trg-wrap').find('.hover-trg').removeClass('-active');
        $('.hover-trg-ref').removeClass('-active');
        $(this).addClass('-active');
        let parent = $(this).attr('data-ref');
        document.getElementById(parent).classList.add('-active');
      }
    });
    $('.hover-trg').on('click', function (e) {
      e.preventDefault();
      if ($(window).width() < 769) {
        //$('body').toggleClass("active-form-contact");
        $(this).closest('.hover-trg-wrap').find('.hover-trg').removeClass('-active');
        $('.hover-trg-ref').removeClass('-active');
        $(this).addClass('-active');
        let parent = $(this).attr('data-ref');
        document.getElementById(parent).classList.add('-active');
      }
    });   

    /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('britech_store_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('britech_store_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('britech_store_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('britech_store_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });     

    //Offcanvas Form trigger
    var formTrigger = document.getElementsByClassName("form-trigger-btn"),
        offcanvasForm = document.getElementById("main-menu");
    
    var toggleCanvasForm = function() {
        /*offcanvasForm.classList.toggle("main-menu-active");*/
        document.body.classList.toggle("active-form-contact");
    };

    for (var i = 0; i < formTrigger.length; i++) {
        formTrigger[i].addEventListener('click', toggleCanvasForm, false);
    }    

    //Offcanvas Form trigger on hash
    $('a[href*="#trg-contactform"]').on('click', function (e) {
      e.preventDefault();
      $('body').toggleClass("active-form-contact");
    });

    /*Tiny slider primary*/
    const tnsSliderHighlight = document.querySelectorAll('.-hg-tns');
    tnsSliderHighlight.forEach(sliderHG => {
      const tnsSliderHighlight = tns({
          container: sliderHG,
          mode: "gallery",
          items: 1,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: true,
          mouseDrag: true,
      });
    });     

    /*Tiny slider cases*/
    const tnsSliderCases = document.querySelectorAll('.-cases-tns');
    tnsSliderCases.forEach(sliderCases => {
      const tnsSliderCases = tns({
          container: sliderCases,
          items: 2,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 30,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],
          responsive: { 
              1366: {
                items: 2,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 2,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    }); 

    /*Tiny slider advantage*/
    const tnsSliderAdv = document.querySelectorAll('.-advantage-tns');
    tnsSliderAdv.forEach(sliderAdv => {
      const tnsSliderAdv = tns({
          container: sliderAdv,
          items: 1,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: true,
          mouseDrag: true,
          /*controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],*/
                 
      });
    });     

    /*Tiny slider midia*/
    const tnsSliderPress = document.querySelectorAll('.-press-tns');
    tnsSliderPress.forEach(sliderPress => {
      const tnsSliderPress = tns({
          container: sliderPress,
          items: 3,
          nav: true,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 40,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="carbon:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="carbon:chevron-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                controls: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                controls: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                controls: false,
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    }); 

    /*Tiny slider about*/
    const tnsSliderAbout = document.querySelectorAll('.-about-tns');
    tnsSliderAbout.forEach(sliderAbout => {
      const tnsSliderAbout = tns({
          container: sliderAbout,
          items: 1,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 40,
          loop: false,
          mouseDrag: true,
          responsive: { 
              1366: {
                items: 1,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 1,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                /*loop: true,
                autoplay: true,*/
                /*gutter: 0,*/
              }, 
          }           
      });
    });         


    /*content tabs*/
    $('.nav-tab-btn').click(function(){
      event.preventDefault();
      var tabTarget = $(this).data('tab');
      var tabBg = $(this).data('bg');


      $(this).parents('.-sc-adv').each(function(index, el) {
        $(el).attr('data-bg', tabBg)
      });

      /*console.log(tabTarget);*/
      $(this).closest('.tabs-wrap').find('.tabs-content').removeClass('-visible');
      $(this).closest('.tabs-wrap').find('.tabs-content#'+tabTarget).addClass('-visible');
      $(this).closest('.tabs-wrap').find('.nav-tab-btn').removeClass('-active');
      $(this).addClass('-active');

    });      

    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });      
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      /*if ($(window).width() < 769) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }*/
    });

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover iconify-icon').click(function(){
      /*event.preventDefault();
      console.log('h')*/
      if ($(window).width() < 769) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });    

    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor > a");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      if (document.body.classList.contains('home')) {
        //console.log(e.target.href);
        e.preventDefault();
        const header = document.querySelector("header").offsetHeight;
        const href = this.getAttribute("href");
        
        /*if(e.target.href.startsWith("#") ){
          console.log('hh')*/
          const elemtoScroll = document.querySelector(href);
          const offsetTopTarget = document.querySelector(href).offsetTop;
          const offsetTop = offsetTopTarget-header;
          scrollTo(elemtoScroll);
        /*}else{
          document.location.href = e.target.href;
        }*/
      }
      
      /*window.scroll({
        top: offsetTopTarget,
        behavior: "smooth"
      });*/
    }
    function scrollTo(element) {
        const header = document.querySelector("header").offsetHeight;
        const offsetTop = (element.offsetTop)-header;
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: offsetTop
        });
    }    

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      /*console.log(window.innerWidth)*/
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
        }else{
                header[0].classList.remove('-sticky');
        }
    }; 


}(window.jQuery, window, document));